import { createContext } from 'react';
import { AlertCreator, ConfirmCreator } from './useModalCreator';

export interface ModalContextValue {
  alert?: AlertCreator;
  confirm?: ConfirmCreator;
}

export const ModalContext = createContext<ModalContextValue>({});
